import SuperAdminMyAccountComponent from "./SuperAdminMyAccount.container";

export default SuperAdminMyAccountComponent;
